.atm_1u_glywfm{-webkit-appearance:none;}
.atm_1s_glywfm{appearance:none;}
.atm_5j_1y44olf{border-radius:4px;}
.atm_3f_glywfm{border:none;}
.atm_9j_tlke0l{cursor:pointer;}
.atm_e2_14y27yu{height:5px;}
.atm_gi_idpfg4{margin:0;}
.atm_kd_glywfm{outline:none;}
.atm_l8_idpfg4{padding:0;}
.atm_vy_1osqo2v{width:100%;}
.atm_1vym8o7_kb7nvz:hover::-webkit-slider-thumb{opacity:1;}
.atm_eyi2ox_glywfm::-webkit-slider-thumb{appearance:none;}
.atm_med9z3_1aemfod::-webkit-slider-thumb{background:#146EF5;}
.atm_ze3hzo_1ssbidh::-webkit-slider-thumb{border-radius:50%;}
.atm_107qskw_tlke0l::-webkit-slider-thumb{cursor:pointer;}
.atm_1egnro1_dlk8xv::-webkit-slider-thumb{height:14px;}
.atm_1lnppcu_idpfg4::-webkit-slider-thumb{opacity:0;}
.atm_1pm6a20_1r57da3::-webkit-slider-thumb{transition:opacity 200ms;}
.atm_wfr22h_dlk8xv::-webkit-slider-thumb{width:14px;}
.atm_qifb8c_1aemfod::-moz-range-thumb{background:#146EF5;}
.atm_v72n5r_1ssbidh::-moz-range-thumb{border-radius:50%;}
.atm_13ij99g_tlke0l::-moz-range-thumb{cursor:pointer;}
.atm_1vrwzzb_dlk8xv::-moz-range-thumb{height:14px;}
.atm_b33854_dlk8xv::-moz-range-thumb{width:14px;}
.atm_1kf0vw8_1aemfod.atm_1kf0vw8_1aemfod::-moz-range-thumb{border-color:#146EF5;}
.atm_1lnppcu_kb7nvz::-webkit-slider-thumb{opacity:1;}
.atm_26_f5tel5{background:linear-gradient(
    to right,
    #146EF5 0%,
    #146EF5 var(--audio-progress),
    #A1A8B0 var(--audio-progress),
    #A1A8B0 100%
  );}
.atm_26_mvvybz{background:#A1A8B0;}
.atm_9j_73adwj{cursor:default;}
.atm_4luen7_glywfm::-webkit-slider-thumb{display:none;}
.atm_aykitf_glywfm::-moz-range-thumb{display:none;}
.atm_e2_1l7b3ar{height:3px;}
